module.exports = __webpack_public_path__ + "3926db00785d8e7da0c40d2720de9537.jpg";


//////////////////
// WEBPACK FOOTER
// ./photo.jpg
// module id = 493
// module chunks = 0